import React from 'react';
import { FC } from 'react';

export const CheckboxIndeterminate: FC<{}> = () => (
    <svg fill='#FFFFFF' width='24px' height='24px' viewBox='0 0 512 448' transform='scale(0.5)'>
        <g>
            <g>
                <path
                    d='M458.736,181.097H26.334C11.793,181.097,0,192.884,0,207.425v70.215c0,14.541,11.787,26.328,26.334,26.328h432.402
			c14.541,0,26.328-11.787,26.328-26.328v-70.215C485.07,192.884,473.283,181.097,458.736,181.097z'
                />
            </g>
        </g>
    </svg>
);
